import { cn } from '@heidi/utils';
import type { ReactNode } from 'react';

interface WorkHomeContextStripProps {
  children: ReactNode;
  placement: 'above' | 'below';
  testId: string;
  className?: string;
}

/** Shared inset strip that visually docks supporting context to the composer. */
export function WorkHomeContextStrip({
  children,
  placement,
  testId,
  className,
}: WorkHomeContextStripProps): JSX.Element {
  return (
    <div
      className={cn(
        'relative z-0 mx-auto flex min-h-14 w-[calc(100%-1rem)] items-center justify-between gap-2 border border-border bg-surface-container px-3 shadow-sm sm:w-[calc(100%-3rem)] sm:px-4',
        placement === 'above'
          ? 'rounded-t-2xl pb-3 pt-2'
          : '-mt-2 rounded-b-2xl pb-2 pt-3',
        className
      )}
      data-testid={testId}
    >
      {children}
    </div>
  );
}
